/**
 * `RootAppLayout` element IDs.
 */
export const rootAppLayoutElementIDs = {
  root: "root-app-layout__root",
  rrdOutletContainer: "root-app-layout__rrd-outlet-container",
} as const;
